<template>
    <div>
        <div class="block-bid-prebid" v-if="checkStateAuction == 4 || (checkStateAuction == 5 && checkAvailableTime)">
            <div class="block-bid">
                <div class="block-time-end mb-4">
                    <div class="block-top">
                        <div class="text">残り時間</div>
                        <div class="time-end">
                            <span class="number">{{ timeEnd }}</span>
                        </div>
                    </div>
                </div>
                <div class="block-sm" :style="{ zIndex: blockSmZIndex }">
                    <div class="btn-collapse d-lg-none"
                         data-toggle="collapse" data-target="#collapse-bid" aria-expanded="false" aria-controls="collapse-bid">
                    </div>
                    <div class="block-current-price">
                        <div class="current-price border-color-red">
                            <div class="top">
                                <div v-if="this.isError" class="d-flex justify-content-center pb-10">
                                    <div class="font-weight-bold text-center not-available-product">
                                        販売終了
                                    </div>
                                </div>
                                <div class="text-price-now font-weight-bold">
                                    現在価格
                                </div>
                                <div class="price color-red">
                                    <span class="number">¥</span>
                                    <span class="number">{{
                                        formatPrice(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                                </div>
                                <div class="tax-fee">
                                    <span class="text">消費税手数料込</span>
                                    <span class="number">¥ {{
                                        handlePriceTaxAndServiceFee(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="collapse-bid" class="collapse show">
                        <div class="block-noti">
                            <div v-if="myBidTop">
                                <div class="text-updated"
                                     v-if="checkBidTop == 'type1'">
                                    <i class="icon fas fa-exclamation-circle"></i>
                                    <span>最低落札価格に達していません。</span>
                                </div>
                                <div class="text-updated"
                                     v-else-if="checkBidTop == 'type2' && this.bidTop">
                                    <i class="icon fas fa-exclamation-circle"></i>
                                    <span>あなたより他のお客様が高値で入札しました。</span>
                                </div>
                                <div class="text-updated" v-else-if="checkBidTop == 'type3' && this.bidTop">
                                    <i class="icon fas fa-exclamation-circle"></i>
                                    <span>あなたが現在の最高額入札者です。</span>
                                </div>
                            </div>
                        </div>
                        <div class="block-enter-bid">
                            <div class="left">事前入札額のご入力</div>
                        </div>
                        <div class="block-prie-bid">
                            <div class="block-top">
                                <div class="block-input">
                                    <input type="text" id="input-bid" class="input-bid"
                                           v-model="pricePlaced" @input="validateNumberInput()">
                                </div>
                            </div>
                            <div id="errors-price" class="error d-none">現在価格より大きい価格を入力してください。</div>
                            <div class="block-center">
                                <button class="btn-price-up ml-2" @click="increaseBidPrice('min')" :disabled="this.isError">
                                    + ¥ 1,000 </button>
                                <button class="btn-price-up" @click="increaseBidPrice('medium')" :disabled="this.isError">
                                    + ¥ 5,000 </button>
                                <button class="btn-price-up" @click="increaseBidPrice('max')" :disabled="this.isError">
                                    + ¥ 10,000 </button>
                            </div>
                            <div class="block-bottom">
                                <button class="btn-send-price btn-large"
                                        @click.prevent="handleSavePricePreBid"
                                        :disabled="this.isError"
                                >
                                    入札する
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-history mt-4">
                <div class="text-history text-center">
                    入札履歴
                    <span> （{{ countHistory }}件）</span>
                </div>
                <div class="history">
                    <div class="">
                        <div class="item-history" v-for="history in histories">
                            <div class="left-history ml-4">
                                <button class="tag tag-black">事前入札</button>
                            </div>
                            <div class="right-history">
                                <div class="top"><strong>{{ history.member_id == member.id ? 'あなたの入札' : '' }}</strong>
                                    ¥{{ formatPrice(history.amount) }}
                                </div>
                                <div class="bottom">{{ formatDate(history.created_at) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal -->
            <div class="block-bid-prebid">
                <div class="block-bid">
                    <div class="block-sm">
                        <div class=" block-prie-bid">
                            <div class="block-bottom">
                                <div style="z-index: 1050" class="modal fade" id="priceBidProductModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                                     aria-hidden="true" data-backdrop="static">
                                    <div class="modal-dialog transform-modal">
                                        <div class="modal-content">
                                            <div class="modal-header border-bottom-0">
                                                <h3 class="modal-title font-weight-bold text-right" style="width: 59%">入札確認</h3>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="setZindex()">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="text-center mt-4">
                                                <span>入札価格 :</span>
                                                <span class="color-red">¥{{ formatPrice(pricePlaced) }}</span>
                                            </div>
                                            <div class="text-center mt-1">
                                                <span>手数料含む</span>
                                                <span>(¥{{
                                                handlePriceTaxAndServiceFee(pricePlaced)
                                            }})</span>
                                            </div>
                                            <div class="text-center mt-1 mb-4">
                                                <span>この金額で入札する</span>
                                            </div>
                                            <div class="modal-footer border-top-0 justify-content-center">
                                                <button @click="storeBidPreBid()" class="btn btn-submit-modal-bid-price-product">はい</button>
                                                <button @click="setZindex()" type="button" class="btn btn-cancel-modal-bid-price-product" data-dismiss="modal">いいえ</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="block-bid-prebid" v-else>
            <div class="block-bid">
                <div class="block-sm">
                    <div class="block-noti">
                        <div class="text-updated">
                            <i class="icon fas fa-exclamation-circle"></i>
                            <span>オークション期間は終了しました。</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal end pre bid -->
        <div class="block-bid-prebid">
            <div class="block-bid">
                <div class="block-sm">
                    <div class=" block-prie-bid">
                        <div class="block-bottom">
                            <div style="z-index: 1050" class="modal fade" id="endPreBid" tabindex="-1" aria-labelledby="exampleModalLabel"
                                 aria-hidden="true" data-backdrop="static">
                                <div class="modal-dialog transform-modal">
                                    <div class="modal-content">
                                        <div class="modal-header border-bottom-0"></div>
                                        <div class="text-center">
                                            <span>事前入札時間が終了しました。</span>
                                        </div>
                                        <div class="modal-footer border-top-0 justify-content-center">
                                            <button @click="gotoDetailAuction()"
                                                    type="button" class="btn btn-cancel-modal-bid-price-product"
                                                    data-dismiss="modal">
                                                はい
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONSTANTS from "../constants";
import moment from "moment-timezone";
import {COMMON} from "./../../common";

export default {
    mounted() {

    },
    async created() {
        await this.getDataBid();
        await this.getAuctionProduct();

        Echo.channel('auction.check_error_product' + this.auction.id + '.' + this.product.id)
            .listen('.auction.check_error_product',  (e) => {
                this.getAuctionProduct();
            });

        Echo.channel('bid.pre_bid.' + this.auction.id + '.' + this.product.id)
            .listen('.bid.pre_bid.sent', (e) => {
                this.histories.unshift(e.myBid)
                this.bidTop = e.bidTop;
                this.countHistory = this.histories.length;
            });

        Echo.channel('bid.update_price.' + this.auction.id + '.' + this.product.id)
            .listen('.bid.update_price.sent', (e) => {
                this.histories.unshift(e.myBid)
                this.bidTop = e.bidTop;
                this.countHistory = this.histories.length;
            });

        Echo.channel('bid.pre_bid.' + this.auction.id)
            .listen('.bid.pre_bid.start', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;

                    if (this.checkStateAuction == 4 && this.auction.state != 4) {
                        this.countDownTime();

                        this.interval = setInterval(() => {
                            this.countDownTime();
                        }, 1000);
                    }
                }
            });

        Echo.channel('bid.pre_bid.' + this.auction.id)
            .listen('.bid.pre_bid.end', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;

                    if (this.checkStateAuction == 5 && !this.checkAvailableTime) {
                        $('#endPreBid').modal('show');
                    }
                }
            });

        if ((this.checkStateAuction == 4 && this.auction.state == 4) || (this.checkStateAuction == 5 && this.checkAvailableTime)) {
            this.countDownTime();

            this.interval = setInterval(() => {
                this.countDownTime();
            }, 1000);
        }

        Echo.channel('auction.' + this.auction.id)
            .listen('.auction.setting.product_end_time', (e) => {
                if (this.auction.id == e.auction.id) {
                    window.location.reload();
                }
            });
    },
    props: [
        'product',
        'auction',
        'product_auction'
    ],
    data: function () {
        return {
            serviceFee: 0,
            tax: 0,
            countHistory: 0,
            pricePlaced: 0,
            timeEnd: null,
            interval: null,
            bidTop: null,
            myBidTop: null,
            member: null,
            histories: null,
            checkStateAuction: this.auction.state,
            checkProductAuction: this.product_auction,
            isError: false,
            currentTime: moment().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss'),
            blockSmZIndex: 0
        }
    },
    methods: {
        async getDataBid() {
            await axios.post('/bid/get-data-bid-pre-bid', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.pricePlaced = res.data.myBidTop ? this.formatPrice(res.data.myBidTop.amount) : 0;
                    this.bidTop = res.data.bidTop;
                    this.member = res.data.member;
                    this.histories = res.data.histories;
                    this.myBidTop = res.data.myBidTop;
                    this.countHistory = res.data.histories ? res.data.histories.length : 0;
                    this.serviceFee = res.data.taxConfig.service_fee
                    this.tax = res.data.taxConfig.tax
                })
                .catch(error => {

                })
        },

        async getAuctionProduct() {
            await axios.post('/bid/get-data-auction-product', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.checkProductAuction = res.data.auctionProduct;
                    this.isError = !!res.data.auctionProduct.is_error;
                })
                .catch(error => {

                })
        },

        async storeBidPreBid() {
            this.blockSmZIndex = 0;
            if ((this.checkStateAuction == 4 || (this.checkStateAuction == 5 && this.checkAvailableTime)) &&
                this.checkBidPermission() == CONSTANTS.CAN_BID) {
                this.clearValue();

                if (!document.getElementById('errors-price').classList.contains('d-none')) {
                    document.getElementById('errors-price').classList.add('d-none')
                }

                if (this.bidTop) {
                    if (this.pricePlaced && this.bidTop && this.pricePlaced > this.bidTop.amount) {
                        await axios.post('/bid/store-pre-bid', {
                            auctionId: this.auction.id,
                            productId: this.product.id,
                            amount: this.pricePlaced,
                        })
                            .then(response => {
                                if (response.data.myBidTop) {
                                    this.myBidTop = response.data.myBidTop;
                                    this.getDataBid();
                                }
                            })
                            .catch(error => {
                                if(error.response.status === 422) {
                                    alert('オークション期間は終了しました。');
                                    window.location.reload();
                                }
                            })
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                    this.closeModal();
                } else {
                    if (this.pricePlaced && this.pricePlaced > this.product.price_start_bid) {
                        await axios.post('/bid/store-pre-bid', {
                            auctionId: this.auction.id,
                            productId: this.product.id,
                            amount: this.pricePlaced,
                        })
                            .then(response => {
                                if (response.data.myBidTop) {
                                    this.myBidTop = response.data.myBidTop;
                                    this.getDataBid();
                                }
                            })
                            .catch(error => {
                                if(error.response.status === 422) {
                                    alert('オークション期間は終了しました。');
                                    window.location.reload();
                                }
                            })
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                    this.closeModal();
                }
            } else {
                switch (this.checkBidPermission()) {
                    case CONSTANTS.NOT_MEMBER:
                        document.getElementsByClassName('not-member')[0].classList.remove('d-none');
                        break;
                    case CONSTANTS.CAN_NOT_BID:
                        document.getElementsByClassName('can-not-bid')[0].classList.remove('d-none');
                        break;
                }
                document.getElementById('input-bid').value = '';
                this.closeModal();
            }
        },

        gotoDetailAuction() {
            window.location.href = `/auction/${this.auction.id}/detail`;
            $('#endPreBid').modal('hide');
        },

        clearValue() {
            return document.getElementsByClassName('input-bid')[0].value = '';
        },

        formatPrice(price) {
            return COMMON.handleFormatPrice(price);
        },

        increaseBidPrice(type) {
            if (!this.isError) {
                this.partIntPricePlaced();
                if (this.pricePlaced) {
                    this.checkTypeAddPrice(type, this.pricePlaced);
                } else {
                    if (this.bidTop) {
                        this.checkTypeAddPrice(type, this.bidTop.amount);
                    } else {
                        this.checkTypeAddPrice(type, this.product.price_start_bid);
                    }
                }
            }
        },

        checkTypeAddPrice(type, price) {
            if (type === 'min') {
                this.pricePlaced = price + 1000;
            } else if (type === 'medium') {
                this.pricePlaced = price + 5000;
            } else {
                this.pricePlaced = price + 10000;
            }
        },

        countDownTime() {
            this.timeEnd = COMMON.handleCountDownTime(this.checkProductAuction.end_bid_pre_bid_time, this.auction.prebid_end_time, this.auction.prebid_start_time, this.interval);
            if(this.timeEnd === "0 : 0 : 0 ") {
                this.currentTime = moment().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss')
            }
            return this.timeEnd;
        },

        formatDate(time) {
            return COMMON.handleFormatDate(time);
        },

        validateNumberInput() {
            this.pricePlaced = COMMON.maximumCharacterLimitPrice(event.target.value.replace(/[^0-9]/g, ''));
        },

        checkBidPermission() {
            if (this.member.status != 1) {
                return CONSTANTS.NOT_MEMBER;
            }

            return CONSTANTS.CAN_BID;
        },

        handlePriceTaxAndServiceFee(pricePresent) {
            let price = COMMON.handlePriceTaxAndServiceFee(pricePresent, this.serviceFee, this.tax);

            return this.formatPrice(price);
        },

        partIntPricePlaced () {
            if (this.pricePlaced && typeof this.pricePlaced === 'string') {
                this.pricePlaced = parseInt(this.pricePlaced.replace(/[^0-9]/g, ''))
            }
        },

        handleSavePricePreBid() {
            if (!this.isError) {
                this.partIntPricePlaced();
                if (this.bidTop) {
                    if (this.bidTop.amount < this.pricePlaced) {
                        this.openModal();
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                } else {
                    if (this.product.price_start_bid < this.pricePlaced) {
                        this.openModal();
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                }
            }
        },

        openModal() {
            $('#priceBidProductModal').modal('show');
            this.blockSmZIndex = 0;
        },

        closeModal() {
            $('#priceBidProductModal').modal('hide');
        },

        setZindex() {
            this.blockSmZIndex = 0;
        },
    },
    computed: {
        checkBidTop: function () {
            if (
                this.myBidTop && this.myBidTop.amount < this.product.price_lowest_winning
            ) {
                return 'type1'
            }

            if (
                this.bidTop && this.bidTop.member_id != this.member.id
            ) {
                return 'type2'
            }

            if (
                this.bidTop && this.bidTop.member_id == this.member.id
            ) {
                return 'type3'
            }

            return null;
        },

        checkAvailableTime: function () {
            if(this.checkProductAuction.end_bid_pre_bid_time !== null) {
                let productEndPreBid = moment(this.checkProductAuction.end_bid_pre_bid_time).format('YYYY-MM-DD HH:mm:ss');
                let auctionEndPreBid = moment(this.auction.prebid_end_time).format('YYYY-MM-DD HH:mm:ss');
                let auctionLiveTime = moment(this.auction.start_time).format('YYYY-MM-DD HH:mm:ss');
                if ((productEndPreBid > auctionEndPreBid) &&
                    ((this.currentTime > auctionEndPreBid) && (this.currentTime < auctionLiveTime)) &&
                    (productEndPreBid > this.currentTime)) {
                    return true;
                }
            }

            return false;
        },
    },
}
</script>
